/* WAAP Parts Pro theme script. No dependencies. */
(() => {
  'use strict';
  const W = window.WAAP || { routes: {} };
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* storage unavailable */ } }
  };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const fmt = W.moneyFormat || '${{amount}}';
    const val = (Number(cents) / 100);
    const withDelims = (n, d, t = ',', dec = '.') => {
      const p = n.toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return p.join(dec);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return withDelims(val, 0);
        case 'amount_with_comma_separator': return withDelims(val, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(val, 0, '.', ',');
        default: return withDelims(val, 2);
      }
    });
  }

  /* ---------- Header ---------- */
  const header = $('[data-site-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Announcement rotation
  $$('[data-announce]').forEach(bar => {
    const msgs = $$('.announce__msg', bar);
    if (msgs.length < 2) return;
    let i = 0;
    setInterval(() => {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, Number(bar.dataset.speed || 5) * 1000);
  });

  // Mega menu: click/keyboard support (hover handled by CSS)
  $$('[data-mega-toggle]').forEach(btn => {
    const item = btn.closest('.nav__item');
    btn.addEventListener('click', e => {
      // Mouse users: hover opens the panel and a click goes to the category page.
      // Touch users: first tap opens the panel, second tap follows the link.
      if (window.matchMedia('(hover: hover)').matches || item.classList.contains('is-open')) return;
      e.preventDefault();
      const open = true;
      $$('.nav__item.is-open').forEach(i => { i.classList.remove('is-open'); const b = $('[data-mega-toggle]', i); if (b) b.setAttribute('aria-expanded', 'false'); });
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
  });
  document.addEventListener('click', e => {
    if (!e.target.closest('.nav__item')) $$('.nav__item.is-open').forEach(i => i.classList.remove('is-open'));
  });

  /* ---------- Drawers ---------- */
  const overlay = $('[data-overlay]');
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    closeDrawers();
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.removeAttribute('aria-hidden');
    if (overlay) overlay.hidden = false;
    document.body.classList.add('is-locked');
    const f = d.querySelector('button, a, input, [tabindex]');
    if (f) setTimeout(() => f.focus(), 50);
  }
  function closeDrawers() {
    $$('.drawer.is-open, .facets.is-open').forEach(d => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('is-locked');
    if (lastFocus) { lastFocus.focus(); lastFocus = null; }
  }
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.dataset.drawerOpen); return; }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) closeDrawers();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-qty-btn]');
    if (!b) return;
    const wrap = b.closest('[data-qty]');
    const input = $('input', wrap);
    const min = Number(input.min || 0);
    const step = Number(input.step || 1);
    let v = Number(input.value || 0) + (b.dataset.qtyBtn === 'plus' ? step : -step);
    if (v < min) v = min;
    if (input.max && v > Number(input.max)) v = Number(input.max);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(el => { el.textContent = count; el.dataset.count = count; });
  }
  function renderDrawer(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer-inner]');
    const cur = $('[data-cart-drawer-inner]');
    if (fresh && cur) cur.replaceWith(fresh);
    const c = doc.querySelector('[data-cart-count-source]');
    if (c) updateCount(c.dataset.cartCountSource);
  }
  async function cartAdd(form, btn) {
    const fd = new FormData(form);
    if (W.cartType === 'drawer') fd.append('sections', 'cart-drawer');
    btn && btn.classList.add('is-loading');
    const errEl = $('[data-form-error]', form.closest('[data-product-root]') || form);
    if (errEl) errEl.hidden = true;
    try {
      const res = await fetch(W.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'This part could not be added.');
      if (W.cartType === 'drawer' && data.sections) {
        renderDrawer(data.sections['cart-drawer']);
        openDrawer('CartDrawer');
      } else {
        window.location.href = W.routes.cart;
      }
    } catch (err) {
      if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
      else alert(err.message);
    } finally {
      btn && btn.classList.remove('is-loading');
    }
  }
  document.addEventListener('submit', e => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    cartAdd(form, form.querySelector('[type="submit"]'));
  });

  async function cartChange(key, quantity) {
    const drawer = $('#CartDrawer');
    drawer && drawer.classList.add('is-busy');
    try {
      const res = await fetch(W.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: ['cart-drawer'] })
      });
      const data = await res.json();
      if (data.sections) renderDrawer(data.sections['cart-drawer']);
      if (typeof data.item_count === 'number') updateCount(data.item_count);
    } finally {
      drawer && drawer.classList.remove('is-busy');
    }
  }
  document.addEventListener('change', e => {
    const input = e.target.closest('[data-line-qty]');
    if (input && input.closest('#CartDrawer')) cartChange(input.dataset.lineQty, Number(input.value));
    if (input && input.closest('[data-cart-page]')) input.form && input.form.requestSubmit ? input.form.requestSubmit($('[name="update"]', input.form)) : input.form.submit();
  });
  document.addEventListener('click', e => {
    const r = e.target.closest('[data-line-remove]');
    if (r && r.closest('#CartDrawer')) { e.preventDefault(); cartChange(r.dataset.lineRemove, 0); }
  });

  /* ---------- Predictive search ---------- */
  $$('[data-predictive]').forEach(form => {
    const input = $('input[name="q"]', form);
    const results = $('[data-predictive-results]', form);
    if (!input || !results || !W.routes.predictiveSearch) return;
    let timer, ctrl, idx = -1;
    const close = () => { results.hidden = true; input.setAttribute('aria-expanded', 'false'); idx = -1; };
    const fetchResults = async q => {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const params = new URLSearchParams({
        q, section_id: 'predictive-search',
        'resources[type]': 'product,collection,query,page',
        'resources[limit]': '8',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.sku,variants.barcode,vendor,tag,body'
      });
      try {
        const res = await fetch(`${W.routes.predictiveSearch}?${params}`, { signal: ctrl.signal });
        if (!res.ok) return;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('#predictive-search-results');
        if (!inner) return;
        results.innerHTML = inner.innerHTML;
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        idx = -1;
      } catch (e) { /* aborted */ }
    };
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(() => fetchResults(q), 200);
    });
    input.addEventListener('keydown', e => {
      const items = $$('[data-predictive-item]', results);
      if (results.hidden || !items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        idx = e.key === 'ArrowDown' ? Math.min(idx + 1, items.length - 1) : Math.max(idx - 1, -1);
        items.forEach((it, i) => it.setAttribute('aria-selected', String(i === idx)));
      } else if (e.key === 'Enter' && idx > -1) {
        e.preventDefault();
        window.location.href = items[idx].href;
      } else if (e.key === 'Escape') close();
    });
    document.addEventListener('click', e => { if (!form.contains(e.target)) close(); });
    input.addEventListener('focus', () => { if (results.innerHTML.trim() && input.value.trim().length > 1) results.hidden = false; });
  });

  /* ---------- Product page ---------- */
  $$('[data-product-root]').forEach(root => {
    const jsonEl = $('[data-variant-json]', root);
    const form = $('form[data-product-form]', root);
    const idInput = form ? $('input[name="id"]', form) : null;
    const variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    const selects = $$('[data-option-select]', root);

    // Gallery
    const slides = $$('.gallery__slide', root);
    const thumbs = $$('.gallery__thumb', root);
    const showSlide = mediaId => {
      let found = false;
      slides.forEach(s => { const on = s.dataset.mediaId === String(mediaId); s.classList.toggle('is-active', on); if (on) found = true; });
      thumbs.forEach(t => t.setAttribute('aria-current', String(t.dataset.mediaId === String(mediaId))));
      return found;
    };
    thumbs.forEach(t => t.addEventListener('click', () => showSlide(t.dataset.mediaId)));

    const setText = (sel, v) => $$(sel, root).forEach(el => { el.textContent = v; });

    function onVariantChange() {
      const values = selects.map(s => s.value);
      const v = variants.find(x => x.options.every((o, i) => o === values[i]));
      const btns = $$('[data-atc]', document);
      if (!v) {
        btns.forEach(b => { b.disabled = true; b.querySelector('span').textContent = 'Unavailable'; });
        return;
      }
      if (idInput) idInput.value = v.id;
      setText('[data-variant-sku]', v.sku || '');
      setText('[data-variant-barcode]', v.barcode || '');
      setText('[data-price-current]', formatMoney(v.price));
      setText('[data-price-ex]', formatMoney(Math.round(v.price / 1.1)));
      $$('[data-price-compare]', root).forEach(el => { el.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : ''; el.hidden = !(v.compare_at_price > v.price); });
      $$('[data-price-wrap]', root).forEach(el => el.classList.toggle('price--sale', v.compare_at_price > v.price));
      const orderIn = v.available && !v.in_stock;
      $$('[data-stock]', root).forEach(el => { el.className = 'stock stock--' + v.stock_class; el.textContent = v.stock_label; });
      $$('[data-stock-note]', root).forEach(el => { el.hidden = !orderIn; });
      $$('[data-order-in-notice]', root).forEach(el => { el.hidden = !orderIn; });
      $$('[data-dispatch-note]', root).forEach(el => { el.hidden = !(v.available && v.in_stock); });
      $$('[data-order-in-prop]', root).forEach(el => { el.disabled = !orderIn; });
      btns.forEach(b => {
        const sticky = b.hasAttribute('data-sticky-submit');
        b.disabled = !v.available;
        b.querySelector('span').textContent = !v.available ? 'Unavailable' : (v.in_stock ? 'Add to cart' : (sticky ? 'Order in' : 'Order in, add to cart'));
      });
      if (v.featured_media) showSlide(v.featured_media);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    selects.forEach(s => s.addEventListener('change', onVariantChange));

    // Compatible model filter
    const mFilter = $('[data-models-filter]', root);
    if (mFilter) {
      const items = $$('[data-model]', root);
      const out = $('[data-models-result]', root);
      mFilter.addEventListener('input', () => {
        const q = mFilter.value.trim().toLowerCase().replace(/\s+/g, '');
        let n = 0;
        items.forEach(li => {
          const m = li.dataset.model.replace(/\s+/g, '');
          const hit = !q || m.includes(q);
          li.hidden = !hit;
          li.classList.toggle('is-match', !!q && hit);
          if (hit) n++;
        });
        if (out) out.textContent = q ? (n ? `${n} matching model${n === 1 ? '' : 's'}. This part is listed for your model.` : 'No match found. Check your model number or contact us to confirm fitment.') : '';
      });
    }

    // Section nav highlight
    const navLinks = $$('.pd-nav a', root);
    if (navLinks.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(en => {
          if (en.isIntersecting) navLinks.forEach(a => a.classList.toggle('is-active', a.getAttribute('href') === '#' + en.target.id));
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      navLinks.forEach(a => { const t = document.querySelector(a.getAttribute('href')); if (t) io.observe(t); });
    }

    // Sticky add to cart
    const sticky = $('[data-sticky-atc]');
    const mainBtn = form ? $('[type="submit"]', form) : null;
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(mainBtn);
      $('[data-sticky-submit]', sticky)?.addEventListener('click', () => { form.requestSubmit ? form.requestSubmit() : mainBtn.click(); });
    }
  });

  /* ---------- Same day dispatch countdown (cut-off in AWST, UTC+8, no daylight saving) ---------- */
  $$('[data-dispatch-countdown]').forEach(el => {
    const cutoff = Number(el.dataset.cutoff || 14);
    const tz = el.dataset.tz || 'AWST';
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const tick = () => {
      const now = new Date();
      const perth = new Date(now.getTime() + (now.getTimezoneOffset() + 480) * 60000);
      const day = perth.getDay();
      const mins = perth.getHours() * 60 + perth.getMinutes();
      const left = cutoff * 60 - mins;
      if (day >= 1 && day <= 5 && left > 0) {
        const h = Math.floor(left / 60), m = left % 60;
        el.innerHTML = `Order within <b>${h ? h + 'h ' : ''}${m}m</b> for same day dispatch`;
      } else {
        let next = (day + 1) % 7;
        while (next === 0 || next === 6) next = (next + 1) % 7;
        el.innerHTML = `Order now for dispatch <b>${(day >= 1 && day <= 4) ? 'tomorrow' : days[next]}</b> (cut-off ${cutoff > 12 ? cutoff - 12 + 'pm' : cutoff + 'am'} ${tz})`;
      }
    };
    tick();
    setInterval(tick, 30000);
  });

  /* ---------- Recently viewed (handles kept in this browser only) ---------- */
  const RV_KEY = 'parts-shop-recent';
  const recent = (() => { try { return JSON.parse(store.get(RV_KEY) || '[]'); } catch (e) { return []; } })();
  const current = $('[data-product-root]')?.dataset.productHandle;
  if (current) store.set(RV_KEY, JSON.stringify([current, ...recent.filter(h => h !== current)].slice(0, 12)));
  $$('[data-recently-viewed]').forEach(async list => {
    const limit = Number(list.dataset.limit || 5);
    const handles = recent.filter(h => h && h !== current && h !== list.dataset.exclude).slice(0, limit);
    if (!handles.length) return;
    const root = (W.routes.root || '/').replace(/\/$/, '');
    const cards = await Promise.all(handles.map(async h => {
      try {
        const res = await fetch(`${root}/products/${encodeURIComponent(h)}?section_id=product-card-render`);
        if (!res.ok) return null;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const card = doc.querySelector('.card');
        return card ? card.outerHTML : null;
      } catch (e) { return null; }
    }));
    const html = cards.filter(Boolean).map(c => `<li>${c}</li>`).join('');
    if (html) { list.innerHTML = html; list.closest('[data-recently-viewed-wrap]').hidden = false; }
  });

  /* ---------- Genuine / OEM / Generic options for the same original part number ---------- */
  $$('[data-part-options]').forEach(async box => {
    const base = box.dataset.base;
    if (!base) return;
    try {
      const params = new URLSearchParams({ q: base, type: 'product', 'options[prefix]': 'none', section_id: 'part-options' });
      const res = await fetch(`${(W.routes.root || '/').replace(/\/$/, '')}/search?${params}`);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const inner = doc.querySelector('#part-options-results');
      if (!inner || inner.querySelectorAll('.part-option').length < 2) return;
      inner.querySelectorAll('.part-option').forEach(a => {
        if (a.dataset.handle === box.dataset.current) { a.classList.add('is-current'); a.setAttribute('aria-current', 'page'); }
      });
      box.innerHTML = inner.innerHTML;
      box.hidden = false;
    } catch (e) { /* leave hidden */ }
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(async el => {
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.querySelector('.card')) el.innerHTML = inner.innerHTML;
      else el.closest('[data-recommendations-wrap]')?.setAttribute('hidden', '');
    } catch (e) { /* ignore */ }
  });

  /* ---------- Collection filters ---------- */
  const facetForm = $('#FacetsForm');
  if (facetForm) {
    const isDrawer = () => window.matchMedia('(max-width: 1024px)').matches;
    facetForm.addEventListener('change', e => {
      if (e.target.matches('[data-facet-search]')) return;
      if (!isDrawer() || e.target.matches('[data-sort]')) submitFacets();
    });
    function submitFacets() {
      const fd = new FormData(facetForm);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) if (v !== '' && !k.startsWith('_')) params.append(k, v);
      window.location.search = params.toString();
    }
    facetForm.addEventListener('submit', e => { e.preventDefault(); submitFacets(); });
    $$('[data-facet-search]', facetForm).forEach(inp => {
      inp.addEventListener('input', () => {
        const q = inp.value.trim().toLowerCase();
        $$('.facet__opt', inp.closest('.facet')).forEach(o => { o.parentElement.hidden = q && !o.textContent.toLowerCase().includes(q); });
      });
    });
  }

  /* ---------- Grid / list view ---------- */
  const grid = $('[data-product-grid]');
  const toggles = $$('[data-view-btn]');
  if (grid && toggles.length) {
    const apply = v => { grid.dataset.view = v; toggles.forEach(t => t.setAttribute('aria-pressed', String(t.dataset.viewBtn === v))); };
    apply(store.get('waap-view') || grid.dataset.view || 'grid');
    toggles.forEach(t => t.addEventListener('click', () => { apply(t.dataset.viewBtn); store.set('waap-view', t.dataset.viewBtn); }));
  }
})();
